<!-- 增加结课课时修改功能 -->
<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="880px"
    @close="cancel"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="140px"
      class="demo-ruleForm"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="面授课程名称：" prop="courseName">
            <el-select
              v-model="form.courseName"
              placeholder="-请选择面授课程-"
              :disabled="addType === 1 || courseId > -1 || (addType === 2 && status == '已结课')"
              @change="changeCourseName"
            >
              <el-option
                v-for="item in courseNameList"
                :key="item.linkCourseId"
                :label="item.courseName"
                :value="item.linkCourseId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="面授课时：" prop="tiem" v-if="addType === 2">
            <el-select
              v-model="form.tiem"
              placeholder="-请选择面授课时时长-"
              :disabled="addType === 1"
            >
              <el-option
                v-for="item in courseHourLists"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="面授课时：" prop="tiem" v-else>
            <el-select
              v-model="form.tiem"
              placeholder="-请选择面授课时时长-"
              :disabled="addType === 1"
            >
              <el-option
                v-for="item in courseHourList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="20">
          <el-form-item label="面授课时名称：" prop="name">
            <el-input v-model="form.name" :disabled="addType === 1 || (addType === 2 && status == '已结课')"></el-input>
          </el-form-item>
        </el-col>
        <!-- 面授课开课管理没有综合测验 addType == 1-->
        <el-col :span="4" v-if="hasType">
            <el-checkbox v-model="isTest" :disabled="isTests" @change="onChange">综合测验</el-checkbox>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="面授时间：" prop="openTime">
            <el-date-picker
              v-model="form.openTime"
              type="datetime"
              placeholder="年 / 月 / 日"
              value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="addType === 1 || (addType === 2 && status == '已结课')"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="结束时间：" prop="endTime">
            <el-date-picker
              v-model="form.endTime"
              type="datetime"
              placeholder="年 / 月 / 日"
              value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="addType === 1 || (addType === 2 && status == '已结课')"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-col :span="23">
            <el-form-item label="面授班级：" prop="class">
              <el-input
                type="textarea"
                :rows="1"
                resize="none"
                autosize
                v-model="form.class"
                disabled
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1" class="choose_class" v-if="!courseId">
            <div @click="chooseClass">+</div>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="面授地址：" prop="address">
            <el-input
              v-model="form.address"
              :disabled="addType === 1 || (addType === 2 && status == '已结课')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="面授说明：" prop="explain">
            <el-input
              type="textarea"
              :rows="3"
              v-model="form.explain"
              :disabled="addType === 1 || (addType === 2 && status == '已结课')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 操作部分 -->
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; justify-content: center"
    >
      <el-button v-if="addType === 2" type="primary" @click="add">
        保存修改
      </el-button>
      <el-button v-if="addType === 0" type="primary" @click="add">
        确定
      </el-button>
      <el-button @click="cancel">返回</el-button>
      <el-button
        v-if="addType === 1 && status === '未开课'"
        type="primary"
        @click="edit"
      >
        修改
      </el-button>
    </span>

    <ChooseClass
      ref="chooseClass"
      :classType="1"
      :addType="addType"
      @choseClasses="choseClasses"
    />
  </el-dialog>
</template>

<script>
/**
 * 添加面授|直播弹窗
 *
 **/ 
import ChooseClass from './chooseClass.vue'
import * as api from '@/api/TeacherClassroomManagement/MyClassroomTutorialsAndLive'
// import ClassOpeningListVue from '../../ClassManagement/Class-openingList.vue'
export default {
  components: {
    ChooseClass,
  },
  props: ['addType', 'status', 'editHourParams','hasType',"ids","isTestType"],
  data() {
    // const patternPositiveInteger = /^[0-9]\d*$/ //正整数
    // const validPositiveInteger = (rule, value, callback) => {
    //   patternPositiveInteger.test(value) ? callback() : callback(new Error('目标值必须为正整数'))
    // }
    return {
      dialogVisible: true,
      courseId: this.$route.query.courseId,
      id: this.$route.query.id,
      form: {
        courseName: '',
        tiem: '',
        name: '',
        openTime: '',
        endTime: '',
        class: '',
        address: '',
        explain: '',
      },
      isTest:false, // 综合测验
      isTests:false, // 判断是否禁用
      rules: {
        courseName: [{ required: true, message: '不能为空', trigger: 'blur' }],
        tiem: [
          { required: true, message: '不能为空', trigger: 'blur' },
          // { validator: validPositiveInteger, trigger: 'blur' },
        ],
        name: [{ required: true, message: '不能为空', trigger: 'blur' }],
        openTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
        endTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
        class: [{ required: true, message: '不能为空', trigger: 'blur' }],
        address: [{ required: true, message: '不能为空', trigger: 'blur' }],
        explain: [{ required: true, message: '不能为空', trigger: 'blur' }],
      },
      courseNameList: [],
      courseHourLists:[
        {
          value: '0',
          label: '0'
        },{
          value: '1',
          label: '1'
        }, {
          value: '2',
          label: '2'
        }, {
          value: '3',
          label: '3'
        }, {
          value: '4',
          label: '4'
        }, {
          value: '5',
          label: '5'
        }, {
          value: '6',
          label: '6'
        }, {
          value: '7',
          label: ''
        }, {
          value: '8',
          label: '8'
        }, {
          value: '9',
          label: '9'
        }, {
          value: '10',
          label: '10'
        }, {
          value: '11',
          label: '11'
        }, {
          value: '12',
          label: '12'
        }
      ],
      courseHourList:[
        {
          value: '1',
          label: '1'
        }, {
          value: '2',
          label: '2'
        }, {
          value: '3',
          label: '3'
        }, {
          value: '4',
          label: '4'
        }, {
          value: '5',
          label: '5'
        }, {
          value: '6',
          label: '6'
        }, {
          value: '7',
          label: ''
        }, {
          value: '8',
          label: '8'
        }, {
          value: '9',
          label: '9'
        }, {
          value: '10',
          label: '10'
        }, {
          value: '11',
          label: '11'
        }, {
          value: '12',
          label: '12'
        }
      ],
      choseClass: [],
      isEchoNum: 0,
      albumId: '',
      batchId: '',
      courseVid: '',
    }
  },
  computed: {
    title() {
      const arr = ['添加面授课时', '面授课时信息', '修改面授课时信息']
      return arr[this.addType]
    },
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
  created() {
    this.getMyOpenCourse()
    this.getHasTest()
    console.log("isTest",this.isTestType);
  },
  methods: {
    datetimeFormat(val) {
      if (!val) {
        return ''
      }
      const dt = new Date(val)
      const y = dt.getFullYear()
      const m = (dt.getMonth() + 1 + '').padStart(2, '0')
      const d = (dt.getDate() + '').padStart(2, '0')

      const hh = (dt.getHours() + '').padStart(2, '0')
      const mm = (dt.getMinutes() + '').padStart(2, '0')
      const ss = (dt.getSeconds() + '').padStart(2, '0')
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    },
    async getEditHour() {
      let {
        id,
        name,
        videoId: courseName,
        tiem,
        openTime,
        endTime,
        address,
        explain,
        batch,
        batchId,
      } = this.editHourParams
      console.log("参数 ==>",this.editHourParams);
      console.log("存在吗?",this.courseNameList);
      this.courseVid = this.courseNameList.find(
        (item) => item.linkCourseId === courseName
      ).vid

      openTime = this.datetimeFormat(openTime)
      endTime = this.datetimeFormat(endTime)

      let classText = ''
      this.$refs.chooseClass.courseId = courseName
      const batchData = await this.$refs.chooseClass.getBatchList(batchId)
      const albumIdsArr = batchId.split(',')
      albumIdsArr.forEach((item) => {
        const obj = batchData.find((item2) => item2.batchId == item)
        if (obj) {
          classText += obj.batch + '\n'
          this.choseClass.push(obj)
        }
      })
      this.form = {
        id,
        name,
        courseName,
        tiem,
        openTime,
        endTime,
        address,
        class: classText,
        explain,
        batch,
      }
    },
    // 判断时候添加综合测验 
    getHasTest(){
      console.log("woshi1",this.addType);
        // 添加时候参数
        if(this.addType == 0){
          var datas = {
              batchId: this.id,
          }
        }else{
          // 修改时候 参数
          var datas = {
              id:this.ids,
              batchId: this.id,
          }
        }
        api.getHasTest(datas).then(({ data }) => {
          if (data.code == 100000) {
            console.log("是否存在",this.isTestType);
            // 添加为Y禁止
            if(data.msg == "Y"){
              this.isTest = false
              this.isTests = true
              // this.form.name = ''
              // this.onChange(false)
              // 修改时
              if(this.isTestType && this.isTestType == 1 ){
                // console.log(123);
                this.isTest = true
                this.isTests = true
              }else if(this.isTestType && this.isTestType == 0){
                // console.log(456);
                // 为0时
                this.isTest = false
                this.isTests = true
              }
            }else{
              this.isTest = false
              this.isTests = false
              // console.log(789);
              // 为N允许，并且判断选择状态
              if(this.isTestType && this.isTestType == 1 ){
                this.isTest = true
                this.isTests = true
                this.onChange(true)
              }else if (this.isTestType && this.isTestType == 0){
                // 为0时
                this.isTest = false
                this.isTests = false
              }
           }
            // console.log(data);
          } else {
            that.$message.error(data.msg)
          }
        })
    },
    async getMyOpenCourse() {
      const { data, code } = (
        await api.getMyOpenCourse({
          batchId: this.id,
          courseId: this.courseId,
          uid: localStorage.getItem('uid') ,
          type: 4,
        })
      ).data
       console.log("参数",data);
      if (code === 100000 && data.length >0) {
        this.courseNameList = data
        console.log("有数据了",this.courseNameList);
        if (this.courseId && this.courseNameList[0]) {
          this.form.courseName = this.courseNameList[0].linkCourseId
          this.form.class = this.courseNameList[0].batch
          this.albumId = this.courseNameList[0].albumId
          this.batchId = this.courseNameList[0].batchId
          this.courseVid = this.courseNameList[0].vid
        }
        if (this.addType != 0) {
          this.getEditHour()
        }
      }
    },
    // 综合测验改变的时候触发
    onChange(val){
      console.log(val);
      // 根据传进来的isTestType为1是有综合测验,并允许选择  
        if(val == true){
          let datas = {
              courseId: this.courseId,
          }
          api.getExamsPaperTitle(datas).then(({ data }) => {
            if (data.code == 100000) {
              this.form.name = data.msg
              console.log(data.msg);
            } else {
              this.$message.error(data.msg)
            }
          })
        }else{
          // 为false清空
          this.form.name = ''
        }
      
      
    },
    changeCourseName(val) {
      this.courseVid = this.courseNameList.find(
        (item) => item.linkCourseId === val
      ).vid
      this.isEchoNum++
      this.$refs.chooseClass.courseId = val
      this.$refs.chooseClass.getBatchList()
      this.form.class = ''
    },
    chooseClass() {
      console.log('addType', this.addType)
      if (this.addType === 1 || (this.addType === 2 && this.status == '已结课')) return

      this.$refs.chooseClass.dialogVisible = true
      if (this.addType === 2 && this.isEchoNum < 1) {
        this.isEchoNum++
        const { videoId, batchId } = this.editHourParams
        this.$refs.chooseClass.isEchoTable = true
        this.$refs.chooseClass.courseId = videoId
        this.$refs.chooseClass.getBatchList(batchId)
      } else {
        this.$refs.chooseClass.echoNum++
      }
    },
    choseClasses(msg) {
      this.choseClass = msg
      let choseClass = ''
      msg.forEach((item) => {
        choseClass += item.batch + '\n'
      })
      this.form.class = choseClass
    },
    // 面授课添加，开课面授课添加需要添加是否综合测验isTest字段（1是|0否）
    add() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const {
            id,
            courseName: videoId,
            name,
            tiem,
            openTime,
            endTime,
            address,
            explain,
          } = this.form

          const { vid } = this.courseNameList.find(
            (item) => item.linkCourseId === videoId
          )
          let albumIds = ''
          let batchClassId = ''
          let batchId = ''
          if (this.courseId) {
            albumIds = batchClassId = this.albumId
            batchId = this.batchId
          } else {
            this.choseClass.forEach((item, index) => {
              if (this.choseClass.length > index + 1) {
                albumIds += item.albumId + ','
                batchClassId += item.albumId + '_'
                batchId += item.batchId + ','
              } else {
                albumIds += item.albumId
                batchClassId += item.albumId
                batchId += item.batchId
              }
            })
          }

          const date = new Date()
          const curYear = date.getFullYear()
          const curMonth = date.getMonth() + 1
          const curDate = date.getDate()
          let batch = `XZKJF-${curYear}-${curMonth}-${curDate}-${vid}-${batchClassId}-${videoId}`

          const params = {
            id,
            name,
            videoId,
            tiem,
            openTime,
            endTime,
            albumIds,
            address,
            explain,
            batch,
            batchId,
            courseId: this.courseVid,
            uids: this.getUId,
            isTest: this.isTest == true ? 1 : 0
          }
          console.log("params==>",params);
          const { code, msg } = (await api.saveOrUpdateTeacherCourse(params))
            .data
          if (code === 100000) {
            this.$message.success(msg)
            this.$emit('closeAddTutionHour', 'success')
          } else {
            this.$message.error(msg)
          }
        }
      })
    },
    cancel() {
      this.$emit('closeAddTutionHour')
    },
    edit() {
      this.$emit('changeAddType')
    },
    saveEdit() {},
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  background-color: #d7d7d7;
}
/deep/.el-checkbox{
  margin-top: 10px;
  margin-left: 20px;
}
.choose_class {
  line-height: 36px;
  font-size: 40px;
  font-weight: 700;
  color: #d7d7d7;
  text-align: center;
  cursor: pointer;
}
</style>
